module.exports = __webpack_public_path__ + "assets/img/mtTitle-735ce38f.png";